import React, { useState } from 'react';
import { fetchClientByCode, remindClients } from '../../services/api';
import ClientReminderComponent from '../ClientReminderComponent/ClientReminderComponent';
import MessageBox from '../MessageBox/MessageBox';
import EmailSelector from '../EmailSelector/EmailSelector';
import './clientInvoicesComponent.css';

export default function ClientInvoicesComponent() {
  const [showClientReminderComponent, setShowClientReminderComponent] = useState(false);
  const [showMessageBox, setShowMessageBox] = useState(false);
  const [messageBoxConfig, setMessageBoxConfig] = useState({
    message: '',
    type: 'ok',
    loading_button: false,
    input: false,
    onConfirm: null,
    onCancel: null,
  });
  const [showEmailSelector, setShowEmailSelector] = useState(false);
  const [selectedClients, setSelectedClients] = useState([]);

  const onConfirmClientReminderComponent = selected_clients => {
    if (selected_clients.length > 0) {
      setMessageBoxConfig({
        message: `Envoyer une relance aux ${selected_clients.length} clients sélectionnés ? Un seul mail sera envoyé avec l'ensemble des factures relancées.`,
        type: 'yesno',
        loading_button: true,
        input: false,
        onConfirm: () => {
          setSelectedClients(selected_clients);
          handleShowEmailSelector();
          setShowMessageBox(false);
        },
        onCancel: () => setShowMessageBox(false),
      });
      setShowMessageBox(true);
    } else {
      setMessageBoxConfig({
        message: `Aucun client sélectionné.`,
        type: 'ok',
        loading_button: false,
        input: false,
        onConfirm: () => setShowMessageBox(false),
        onCancel: () => setShowMessageBox(false),
      });
      setShowMessageBox(true);
    }
  };

  const handleShowEmailSelector = () => {
    setShowEmailSelector(true);
  };

  const sendClientReminders = async client_emails => {
    const SendReminders = async client_emails => {
      try {
        const response = await remindClients(selectedClients, client_emails);
        return response;
      } catch (error) {
        setMessageBoxConfig({
          message: `Une erreur est survenue lors de l'envoi des relances: ${error}`,
          type: 'ok',
          onConfirm: () => setShowMessageBox(false),
          onClose: () => setShowMessageBox(false),
        });
        setShowMessageBox(true);
      }
    };

    const response = await SendReminders(client_emails);

    if (response) {
      setMessageBoxConfig({
        message: `La relance clients a bien été envoyée.`,
        type: 'ok',
        onConfirm: () => setShowMessageBox(false),
        onClose: () => setShowMessageBox(false),
      });
      setShowMessageBox(true);
      setShowEmailSelector(false);
      setShowClientReminderComponent(false);
    }
  };

  return (
    <form className="table-sub-heading-component">
      <div className="client-invoices-component">
        <button type="button" onClick={() => setShowClientReminderComponent(true)}>
          Relancer clients
        </button>
      </div>

      {showClientReminderComponent && (
        <ClientReminderComponent
          onClose={() => setShowClientReminderComponent(false)}
          onConfirm={onConfirmClientReminderComponent}
        />
      )}
      {showMessageBox && (
        <MessageBox
          message={messageBoxConfig.message}
          onClose={() => setShowMessageBox(false)}
          onConfirm={messageBoxConfig.onConfirm}
          onCancel={messageBoxConfig.onCancel}
          type={messageBoxConfig.type}
          loading_button={messageBoxConfig.loading_button}
          input={messageBoxConfig.input}
          technicalDetails={messageBoxConfig.technicalDetails}
        />
      )}
      {showEmailSelector && (
        <EmailSelector
          fetchFunction={fetchClientByCode}
          code={selectedClients}
          onClose={() => setShowEmailSelector(false)}
          onConfirm={sendClientReminders}
          onCancel={() => setShowEmailSelector(false)}
        />
      )}
    </form>
  );
}
